const config = {
  rootPath:
    process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'prod'
      ? 'https://clientportal.flagshipsg.com/backend/api'
      : 'http://127.0.0.1:8001/backend/api',
}

export default config
